import React, { useContext, useEffect, useRef, useState } from "react";

import { ArrowIcon, CatalogIcon, CloseIcon, LogoIcon } from "../../../assets/icons/icons";

import "./MenuPopup.css";
import { ConfigContext } from "../../../assets/contexts/configContext";
import MobilePopup from "../../MobilePopup/MobilePopup";
import { Link, NavLink } from "react-router-dom";
import { getURLRelativePath, isExternalURL } from "../../../assets/utils/utils";
import { FAVORITE_LINK } from "../../../assets/utils/constants";

function MenuPopup({ isOpened, setOpened }) {

  const config = useContext(ConfigContext)
  const { initialConstants } = config
  const { FIRST_LEVEL_CATEGORIES, HEADER_LINKS } = initialConstants

  function close() {
    console.log("sas");
    setOpened(false);
    setTimeout(() => {
      setOpened(false);
    }, 1);
  }

  return (
    <MobilePopup
      isOpen={isOpened}
      handleClose={close}
      popupName={'menu'}
      className={'mobile-popup__menu'}
    >
      <div className="menu-popup">
        <button className="menu-popup__close" type="button" onClick={close}>
          <CloseIcon
            mainClassName={"menu-popup__close-icon"}
            fillClassName={"menu-popup__close-icon-fill"}
          />
        </button>
        <div className="menu-popup__heading">
          <LogoIcon
            mainClassName={'menu-popup__logo'}
            fillClassName={'menu-popup__logo-fill'}
          />
        </div>
        <div className="menu-popup__links">
          {HEADER_LINKS && HEADER_LINKS.length > 0 ?
            HEADER_LINKS.map((link) => {
              if (isExternalURL(link.url)) {
                return (
                  <Link
                    key={link._id}
                    className={`menu-popup__link`}
                    to={link.url}
                    onClick={close}
                    // target={'_blank'} // Conditionally set target attribute
                    rel={'noopener noreferrer'} // Add rel for security if external
                  >
                    {link.name}
                  </Link>
                )
              } else {
                const relativePath = getURLRelativePath(link.url);
                return (
                  <NavLink
                    key={link._id}
                    onClick={close}
                    className={({ isActive }) => {
                      return `menu-popup__link ${isActive ? 'menu-popup__link_active' : ''}`
                    }}
                    to={relativePath}
                  >
                    {link.name}
                  </NavLink>
                )
              }
            })
            :
            null
          }
          <NavLink
            onClick={close}
            className={({ isActive }) => {
              return `menu-popup__link menu-popup__link_favorite ${isActive ? 'menu-popup__link_active' : ''}`
            }}
            to={`/${FAVORITE_LINK}`}
          >
            <svg className='hmenu-popup__favorite-icon' width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path className='menu-popup__favorite-icon-fill-and-stroke' d="M17.5173 3C21.3979 3 24 6.725 24 10.1938C24 17.235 13.1968 23 13 23C12.8032 23 2 17.235 2 10.1938C2 6.725 4.60211 3 8.48267 3C10.701 3 12.1579 4.13125 13 5.13875C13.8421 4.13125 15.299 3 17.5173 3Z" fill="white" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Избранные товары
          </NavLink>
        </div>
      </div>
    </MobilePopup >
  );
}

export default MenuPopup;
